import { render, staticRenderFns } from "./reorder.vue?vue&type=template&id=3cc3536f&"
import script from "./reorder.vue?vue&type=script&lang=js&"
export * from "./reorder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports